import React from 'react';
import { HashRouter as Router, Routes, Route } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import NavigationElevated from './components/NavigationElevated';
import FooterElevated from './components/FooterElevated';
import HomeElevated from './pages/HomeElevated';
import ResidentialBuyers from './pages/ResidentialBuyers';
import ResidentialSellers from './pages/ResidentialSellers';
import NewConstruction from './pages/NewConstruction';
import DIYRealEstate from './pages/DIYRealEstate';
import CommercialRealEstate from './pages/CommercialRealEstate';
import AgentsLenders from './pages/AgentsLenders';
import Landlords from './pages/Landlords';
import Renters from './pages/Renters';
import DeedTransfers from './pages/DeedTransfers';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsOfUse from './pages/TermsOfUse';

function App() {
  return (
    <Router>
      <div className="min-h-screen bg-white flex flex-col">
        <NavigationElevated />
        <main className="flex-grow pt-20">
          <AnimatePresence mode="wait">
            <Routes>
              <Route path="/" element={<HomeElevated />} />
              <Route path="/residential-buyers" element={<ResidentialBuyers />} />
              <Route path="/residential-sellers" element={<ResidentialSellers />} />
              <Route path="/new-construction" element={<NewConstruction />} />
              <Route path="/diy-real-estate" element={<DIYRealEstate />} />
              <Route path="/commercial-real-estate" element={<CommercialRealEstate />} />
              <Route path="/agents-lenders" element={<AgentsLenders />} />
              <Route path="/landlords" element={<Landlords />} />
              <Route path="/renters" element={<Renters />} />
              <Route path="/deed-transfers" element={<DeedTransfers />} />
              <Route path="/privacy-policy" element={<PrivacyPolicy />} />
              <Route path="/terms-of-use" element={<TermsOfUse />} />
            </Routes>
          </AnimatePresence>
        </main>
        <FooterElevated />
      </div>
    </Router>
  );
}

export default App;
